import React from 'react';
import {
  ChoiceButton,
  ChoiceButtonGroup,
} from '../../../../styles/lesson/lesson.style';
import {
  useLessonCreationState,
  useLessonCreationDispatch,
} from '../lessonCreation.state';

export const Step3_RecursChoice: React.FC = () => {
  // Get state and dispatch from the context
  const { recursChoice } = useLessonCreationState();
  const dispatch = useLessonCreationDispatch();

  // --- Handlers ---
  const handleChoice = (choice: 'yes' | 'no') => {
    dispatch({ type: 'SET_RECURS_CHOICE', payload: choice });
  };

  // --- Render ---
  return (
    <>
      <ChoiceButtonGroup>
        <ChoiceButton
          isSelected={recursChoice === 'yes'}
          onClick={() => handleChoice('yes')}
        >
          Yes, make it recurring
        </ChoiceButton>
        <ChoiceButton
          isSelected={recursChoice === 'no'}
          onClick={() => handleChoice('no')}
        >
          No, one-time lesson
        </ChoiceButton>
      </ChoiceButtonGroup>
    </>
  );
};